import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Link, useNavigate } from 'react-router-dom';
import './BookingForm.css';

const BookingForm = () => {
  const form = useRef();
  const navigate = useNavigate();
  
  // State to handle the checkbox (terms and conditions)
  const [isChecked, setIsChecked] = useState(false);

  // Handle checkbox change
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

const sendEmail = (e) => {
  e.preventDefault();

  // Check if consent checkbox is checked
  if (!isChecked) {
    alert('Please accept the terms and conditions before submitting.');
    return;
  }

  // Create a new FormData object from the form
  const formData = new FormData(form.current);
  
  // Append the consent value manually to the FormData
  formData.append("consent", isChecked ? "Yes" : "No"); 

  // Convert FormData to an object to make it easier to manipulate
  const formObject = {};
  formData.forEach((value, key) => {
    formObject[key] = value;
  });

  // Log the form object to ensure consent is included
  console.log(formObject);

  // Send the form data along with the consent to EmailJS
  emailjs.send(
    process.env.REACT_APP_EMAILJS_SERVICE_ID,  // This is the service ID from EmailJS
    process.env.REACT_APP_EMAILJS_TEMPLATE_ID,  // This is the template ID from EmailJS
    formObject,  // Send the form data as an object
    process.env.REACT_APP_EMAILJS_PUBLIC_KEY
  )
  .then(() => {
    navigate('/merci'); // Redirect to Thank You page
  })
  .catch((error) => {
    console.error('FAILED...', error.text);
  });
};


  return (
    <div className="container-fluid p-4 shadow ">
      <form ref={form} onSubmit={sendEmail} className="py-5 px-5">
        <h2 className="text-center mt-2 titles"> Réservez votre trajet</h2>

        <div className="mb-3">
          <label className="form-label">Point de départ</label>
          <input type="text" name="depart" className="form-control" placeholder="Adresse de départ" required />
        </div>

        <div className="mb-3">
          <label className="form-label">Destination</label>
          <input type="text" name="destination" className="form-control" placeholder="Adresse d’arrivée" required />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Prénom</label>
            <input type="text" name="lastname" className="form-control" placeholder="Votre prénom" required />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Nom</label>
            <input type="text" name="name" className="form-control" placeholder="Votre nom" required />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Téléphone</label>
            <input type="tel" name="phone" className="form-control" placeholder="+33 6 12 34 56 78" required />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Email</label>
            <input type="email" name="from_email" className="form-control" placeholder="votre@email.com" required />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Numéro de train</label>
            <input type="text" name="trainnumber" className="form-control" placeholder="Ex: TGV 1234" />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Numéro de vol</label>
            <input type="text" name="flightnumber" className="form-control" placeholder="Ex: AF 5678" />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Date</label>
            <input type="date" name="date" className="form-control" required />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Heure</label>
            <input type="time" name="heure" className="form-control" required />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Nombre de passagers</label>
            <input type="number" name="passengers" className="form-control" placeholder="Ex: 2" required />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Nombre de valises</label>
            <input type="number" name="suitcases" className="form-control" placeholder="Ex: 3" />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Message (optionnel)</label>
          <textarea name="message" className="form-control" rows="4" placeholder="Détails supplémentaires, instructions..."></textarea>
        </div>

        <div className="mb-3">
          <label className="form-check-label text-light">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="form-check-input "
            />
            J’accepte les <Link className="text-warning text-decoration-none" to="/policy" target="_blank">Politique de confidentialité et utilisation</Link>
          </label>
        </div>

        <div className="text-center">
          <button type="submit" className="cta-button">
            Réserver maintenant
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookingForm;
